import { IconCheck } from "@tabler/icons-react";
import { useMutation } from "@tanstack/react-query";
import { Button, Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui";
import { toastErrorApi, toastExito } from "@/lib/toast";
import { prorrateoApi } from "../../services/prorrateo.api";

/**
 * Botón principal para confirmar el prorrateo de un CFDI. Se deshabilita
 * cuando la suma no coincide con el subtotal · el tooltip explica el
 * porqué.
 */
export function ConfirmarCfdiBoton({ solicitudId, numeroCfdi, habilitado, motivo, onConfirmado }: { solicitudId: string; numeroCfdi: number; habilitado: boolean; motivo?: string; onConfirmado: () => void }) {
  const m = useMutation({
    mutationFn: () => prorrateoApi.confirmar(solicitudId, numeroCfdi),
    onSuccess: () => {
      toastExito({ title: `CFDI ${numeroCfdi} confirmado`, message: "Prorrateo aceptado." });
      onConfirmado();
    },
    onError: toastErrorApi,
  });

  const boton = (
    <Button size="sm" leftSection={<IconCheck size={14} />} disabled={!habilitado} loading={m.isPending} onClick={() => m.mutate()}>
      Confirmar este prorrateo
    </Button>
  );

  if (habilitado) return boton;

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <span tabIndex={0}>{boton}</span>
      </TooltipTrigger>
      <TooltipContent>{motivo ?? "La suma del prorrateo no coincide con el subtotal"}</TooltipContent>
    </Tooltip>
  );
}
